import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import ScoreWrapper from '../shared/wrapper';
import useSportsStore from '../../../hooks/useSportsStore';
import useScoreViewType from '../../../hooks/useScoreViewType';
import { timeUtils } from '../../../common/utils/timeUtil';
import Seo from '../../../components/seo';
import useStore from "../../../hooks/useStore";
import {_SPORTS_TYPE} from "../../../common/constants/sportsConstants";

const Soccer = observer(() => {
  const {search} = useLocation();
  const store = useSportsStore('soccer');
  const { viewType } = useScoreViewType();
  const { bannerStore } = useStore();

  useEffect(() => {
    bannerStore.setSportType(_SPORTS_TYPE.SOCCER);
    store.getFavoriteGames();

    return () => {
      store.closeSocket();
    };
  }, []);

  useEffect(() => {
    if (search.length > 0) {
      const date = search.split('=')[1];

      if (date === timeUtils.todayYmd()) {
        store.getSoccerToday();
      } else {
        store.getSoccer(date);
      }
    } else {
      store.getSoccerToday();
    }
  }, [search]);

  return (
    <>
      <Seo title={'스포츠 축구'} />
      <div
        className={clsx(
          'game_list',
          viewType === 'VERTICAL_VIEW' && 'vertical_view'
        )}
      >
        <ScoreWrapper
          sportsType={'soccer'}
          loading={store.loading}
          list={store.soccerList}
          selectedGames={store.selectedGames}
          setSelectedGame={store.setSelectedGame}
        />
      </div>
    </>
  );
});

export default Soccer;
